<template>
    <div>
        <radio-checkbox-field
            :field="{label: $t('patient.comorbidities')}"
            field-name="has-comorbidities"
            v-model="hasComorbidities"
        />

        <div v-if="hasComorbidities" class="mx-3">
            <text-area-field
                v-model="relevant_comorbidities"
                :field="patientFields.relevant_comorbidities"
                field-name="comorbidities"
                :inline="false"
                rows="4"
                class="mb-3"
            />
        </div>
    </div>
</template>

<script>
    import ScrollToErrorMixin from "@/components/mixins/ScrollToErrorMixin";
    import RadioCheckboxField from "@/components/fields/RadioCheckboxField";
    import TextAreaField from "@/components/fields/TextAreaField";
    import {mapState} from "vuex";
    import {mapStateProperty} from "@/utils/VuexHelpers";

    export default {
        name: "PatientRelevantComorbidities",
        components: {TextAreaField, RadioCheckboxField},
        mixins: [ScrollToErrorMixin],
        data() {
            return {
                hasComorbidities: null,
            };
        },
        computed: {
            ...mapState(['patientFields']),
            ...mapStateProperty([
                'patient.relevant_comorbidities',
            ]),
        },
        created() {
            this.hasComorbidities = this.relevant_comorbidities !== '';
        },
        methods: {
            validate() {
                this.deleteIfAnswerIsNot();
                return true;
            },
            back() {
                this.deleteIfAnswerIsNot();
                return true;
            },
            deleteIfAnswerIsNot() {
                if (!this.hasComorbidities) {
                    this.relevant_comorbidities = '';
                }
            }
        },
    };
</script>

<style scoped>

</style>